export const BASE_ASSISTANT_REPORT_PATH = '/assistant_reports';

export const INDEX_ASSISTANT_REPORT_PATH = `${ BASE_ASSISTANT_REPORT_PATH }/all`;
export const NEW_ASSISTANT_REPORT_PATH = `${ BASE_ASSISTANT_REPORT_PATH }/new`;
export const SHOW_ASSISTANT_REPORT_PATH = `${ BASE_ASSISTANT_REPORT_PATH }/show/:id`;

export const TODAY_ASSISTANT_REPORT_PATH = `${ BASE_ASSISTANT_REPORT_PATH }/today`;

